const NODE_TYPES = {
  draggingTemp: "dragging_temp",
  entryCondition: "entry_condition",
  note: "note",
  task: "task",
  email: "email",
  timeDelay: "time_delay",
  yesNoSplit: "yes_no_split",
}

export default NODE_TYPES
